import { render, staticRenderFns } from "./cmpselecionarimagem.vue?vue&type=template&id=9b283ffa&scoped=true&"
import script from "./cmpselecionarimagem.vue?vue&type=script&lang=js&"
export * from "./cmpselecionarimagem.vue?vue&type=script&lang=js&"
import style0 from "./cmpselecionarimagem.vue?vue&type=style&index=0&id=9b283ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b283ffa",
  null
  
)

export default component.exports